export const API_OPTIONS = {
  method: 'GET',
  url: 'https://shazam.p.rapidapi.com/songs/list-artist-top-tracks',
  params: {id: '40717346', locale: 'en-US'},
  headers: {
    'x-rapidapi-host': 'shazam.p.rapidapi.com',
    'x-rapidapi-key': 'bd8e9b8c38msh884c82aa15ecfecp1883f3jsn3af8e5818b9d'
  }
};
